import { getPermissionKey } from '@/shared/erc725y'
import {
  SetDataKeyValuePair,
  SetDataSelector,
  SetDataComponentsSelectors,
  DefaultTxComponents,
} from '@/shared/models/Transaction'

export const getSetDataSelector = (
  setDataKey: string,
  setDataValue: string
): SetDataKeyValuePair & SetDataSelector => {
  const foundSetDataSelector = SetDataComponentsSelectors[
    getPermissionKey(setDataKey) || setDataKey
  ] || { component: DefaultTxComponents.SET_DATA }

  return { ...foundSetDataSelector, setDataKey, setDataValue }
}
